const UserActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER'
};

export default UserActionTypes;